import axios from 'axios';
import { CITYSPRINT_BASE_URL } from '../constants/env';

const citysprintApiClient = axios.create({
  baseURL: `${CITYSPRINT_BASE_URL}/citysprint`,
  withCredentials: true,
  transformResponse: axios.defaults.transformResponse.concat(
    params => params.data || params
  ),
});

export const getQuotes = (body, options) =>
  citysprintApiClient.post(`/quotes`, body, options);

export const createQuoteSession = (body, options) =>
  citysprintApiClient.post(`/quotes/session`, body, options);

export const validateQuoteSession = () =>
  citysprintApiClient.get(`/quotes/session/validate`);

export const checkout = (body, options) =>
  citysprintApiClient.post(`/payment/checkout`, body, options);

export const getOrderById = (bookingId, options) =>
  citysprintApiClient.get(`/orders/${bookingId}`, options);

export const getSupportContactNumber = (
  bookingReference,
  deliveryPostcode,
  options
) =>
  citysprintApiClient.get(`/orders/track/${bookingReference}`, {
    params: { deliveryPostcode },
    ...options,
  });

export const getPaymentClientToken = async () => {
  const response = await citysprintApiClient.get(`/payment/clientToken`);
  const {
    data: { token },
  } = response;
  return token;
};

export default citysprintApiClient;
